import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "Our Story" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 glass" data-testid="site-header">
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
          <img src="/oshveda-logo.png" alt="Oshveda Naturals" className="h-12 w-12 object-contain" />
          <span className="flex flex-col leading-tight">
            <span className="font-serif text-xl tracking-tight text-oshveda-primary">Oshveda</span>
            <span className="label-eyebrow !text-[10px] !tracking-[0.3em]">Naturals</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10" data-testid="primary-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm uppercase tracking-[0.2em] transition-colors ${
                  isActive ? "text-oshveda-accent" : "text-oshveda-ink2 hover:text-oshveda-accent"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/shop"
            className="px-6 py-2.5 rounded-full bg-oshveda-primary text-oshveda-bg text-sm tracking-wide hover:bg-oshveda-primaryHover hover:-translate-y-0.5 transition-all"
            data-testid="header-shop-cta"
          >
            Shop Now
          </Link>
        </div>

        <button
          className="md:hidden p-2 text-oshveda-primary"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-oshveda-borderSubtle bg-white/95 backdrop-blur-xl" data-testid="mobile-nav">
          <nav className="container-x flex flex-col py-4 gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 text-sm uppercase tracking-[0.2em] ${
                    isActive ? "text-oshveda-accent" : "text-oshveda-ink2"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/shop"
              onClick={() => setOpen(false)}
              className="mt-3 px-6 py-3 rounded-full bg-oshveda-primary text-oshveda-bg text-sm tracking-wide text-center"
              data-testid="mobile-shop-cta"
            >
              Shop Now
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
